import React, { useEffect, useState } from "react";
import { cmApi } from "./cmApi";
import PolicyCard from "../../../components/compliance/mvp/PolicyCard";

export default function PolicyLibrary() {
  const [policies, setPolicies] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    cmApi
      .listPolicies()
      .then(setPolicies)
      .catch(() => setError("Could not load policies."));
  }, []);

  return (
    <div className="p-6" data-testid="cm-policy-library">
      <h1 className="text-xl font-semibold text-slate-800">Policy Library</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {policies.length === 0 && !error && (
        <p className="mt-4 text-sm text-slate-500">No policies yet.</p>
      )}
      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {policies.map((p) => (
          <PolicyCard key={p.slug} policy={p} />
        ))}
      </div>
    </div>
  );
}
